import { httpService } from '../services/httpService';

import '../contracts/Orders_TvDashboardByStepsResponse';
import type { Orders_TvDashboardByStepsResponseDados } from '../contracts/Orders_TvDashboardByStepsResponse';

/**
 * Composable for the in-store TV board grouped by production step.
 *
 * Owns the GET to the SO TV dashboard-by-steps endpoint and wires the
 * typed + validated `Orders_TvDashboardByStepsResponse` ResponseContract.
 *
 * The endpoint returns PENDING work-order steps grouped by each production
 * step that has `so_production_step_show_on_tv = 1`, ordered by delivery
 * urgency (most urgent first).
 */
export function useSOTvDashboardBySteps() {
  const basePath = '/index.php/so/orders';

  const getTvDashboardBySteps = async (): Promise<Orders_TvDashboardByStepsResponseDados | null> => {
    const response = await httpService.get(`${basePath}/tv_dashboard_by_steps`, {
      responseContract: 'Orders_TvDashboardByStepsResponse',
    });
    if (response.success && response.dados) {
      return response.dados;
    }
    return null;
  };

  return {
    getTvDashboardBySteps,
  };
}
